module.exports = __webpack_public_path__ + "static/media/dramaImg5.0a4d8b97.jpg";